import { render } from "./tree.vue?vue&type=template&id=13919e46&scoped=true&ts=true"
import script from "./tree.vue?vue&type=script&lang=ts"
export * from "./tree.vue?vue&type=script&lang=ts"

import "./tree.vue?vue&type=style&index=0&id=13919e46&lang=less&scoped=true"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13919e46"]])

export default __exports__